var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row transform-unset",
      staticStyle: { transform: "translate(0px, 0px)" },
      attrs: { itemscope: "", itemtype: "https://schema.org/Thing" }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "d-none d-lg-flex col-lg-2 single__thumb-swiper-container"
        },
        [
          _c(
            "div",
            {
              ref: "thumbs",
              staticClass:
                "single__thumb-swiper swiper-container swiper-container-vertical"
            },
            [
              _c(
                "div",
                { staticClass: "swiper-wrapper" },
                _vm._l(_vm.carouselImages, function(imagePreview) {
                  return _c(
                    "div",
                    {
                      staticClass: "swiper-slide",
                      on: {
                        mousedown: function($event) {
                          return _vm.triggerClick($event.target)
                        }
                      }
                    },
                    [
                      imagePreview.isVideo
                        ? _c(
                            "div",
                            {
                              staticClass: "single__video-thumb",
                              attrs: {
                                "data-url": imagePreview.url,
                                "data-type": "video",
                                title: _vm.getItemName() + " video"
                              }
                            },
                            [
                              _c("svg", [
                                _c("use", {
                                  attrs: {
                                    "xlink:href": "#svg_play",
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink"
                                  }
                                })
                              ])
                            ]
                          )
                        : imagePreview.is3d
                        ? _c(
                            "div",
                            {
                              staticClass: "single__3d-thumb",
                              attrs: {
                                "data-url": imagePreview.url,
                                "data-type": "3d",
                                title: _vm.getItemName() + " 3D"
                              }
                            },
                            [
                              _c("svg", [
                                _c("use", {
                                  attrs: {
                                    "xlink:href": "#svg_3d",
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink"
                                  }
                                })
                              ])
                            ]
                          )
                        : _c("img", {
                            key: imagePreview.url,
                            staticClass:
                              "single__thumb-swiper-image swiper-lazy",
                            attrs: {
                              "data-src": imagePreview.url,
                              "data-bigimg": imagePreview.urlBig,
                              "data-type": "img",
                              alt: _vm.getAltText(imagePreview),
                              title: _vm.getItemName(),
                              draggable: "false"
                            }
                          })
                    ]
                  )
                }),
                0
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "thumb-swiper-next" }, [
            _c("svg", [
              _c("use", {
                attrs: {
                  "xlink:href": "#svg_arrow",
                  "xmlns:xlink": "https://www.w3.org/1999/xlink"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "thumb-swiper-prev" }, [
            _c("svg", [
              _c("use", {
                attrs: {
                  "xlink:href": "#svg_arrow",
                  "xmlns:xlink": "https://www.w3.org/1999/xlink"
                }
              })
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-lg-10 single-swiper-container-col" },
        [
          _c(
            "div",
            { staticClass: "single__wishlist-btn single__wishlist-btn--top" },
            [_c("add-to-wish-list")],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "single",
              staticClass: "swiper-container single-swiper",
              on: {
                "~mouseover": function($event) {
                  return _vm.triggerScrollForDrift()
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "swiper-wrapper" },
                _vm._l(_vm.singleImages, function(image, index) {
                  return _c(
                    "div",
                    {
                      staticClass: "swiper-slide",
                      class: {
                        "pointer-events-all": image.isVideo || image.is3d
                      }
                    },
                    [
                      image.isVideo && image.isYoutube
                        ? _c(
                            "div",
                            { staticClass: "responsive-iframe--video" },
                            [
                              _c("iframe", {
                                attrs: {
                                  src:
                                    "https://www.youtube-nocookie.com/embed/" +
                                    image.url,
                                  frameborder: "0",
                                  allow:
                                    "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                                  allowfullscreen: "",
                                  itemprop: "image"
                                }
                              })
                            ]
                          )
                        : image.isVideo && !image.isYoutube
                        ? _c(
                            "div",
                            { staticClass: "responsive-iframe--video" },
                            [
                              _c("iframe", {
                                attrs: {
                                  src:
                                    "https://player.vimeo.com/video/" +
                                    image.url +
                                    "?h=333e7b7c78&badge=0&autopause=0&player_id=0&app_id=58479",
                                  width: "100%",
                                  height: "100%",
                                  frameborder: "0",
                                  allow: "fullscreen",
                                  allowfullscreen: ""
                                }
                              })
                            ]
                          )
                        : image.is3d
                        ? _c(
                            "div",
                            {
                              ref: "threedcontainer",
                              refInFor: true,
                              staticClass: "responsive-iframe--3d"
                            },
                            [
                              _c("iframe", {
                                attrs: {
                                  "data-src": image.url,
                                  frameborder: "0",
                                  allowfullscreen: "",
                                  itemprop: "image"
                                }
                              })
                            ]
                          )
                        : _c(
                            "a",
                            {
                              attrs: { title: _vm.getItemName() },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.openFullScreenModal($event)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "swiper-zoom-container" },
                                [
                                  _c("img", {
                                    key: image.urlMiddle,
                                    staticClass: "single__swiper-image",
                                    class: { "swiper-lazy": index > 0 },
                                    attrs: {
                                      "data-zoom": image.urlBig,
                                      src: index === 0 ? image.urlMiddle : "",
                                      "data-src": image.urlMiddle,
                                      alt: _vm.getAltText(image),
                                      title: _vm.getItemName(),
                                      itemprop: "image"
                                    }
                                  }),
                                  _vm._v(" "),
                                  index > 0
                                    ? _c("div", {
                                        staticClass: "swiper-lazy-preloader"
                                      })
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "single-swiper-pagination" }),
              _vm._v(" "),
              _c("div", {
                staticClass: "drift-pane",
                class: "drift-pane-" + _vm.currentVariation.item.id
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "single-swiper__fullscreen",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.openPhotoSwiper()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$translate("Weberbuero::Template.fullscreen")
                      ) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "swiper-button-next swiper-button-white" },
                [
                  _c("svg", [
                    _c("use", {
                      attrs: {
                        "xlink:href": "#svg_arrow",
                        "xmlns:xlink": "https://www.w3.org/1999/xlink"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "swiper-button-prev swiper-button-white" },
                [
                  _c("svg", [
                    _c("use", {
                      attrs: {
                        "xlink:href": "#svg_arrow",
                        "xmlns:xlink": "https://www.w3.org/1999/xlink"
                      }
                    })
                  ])
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      (_vm.isItemView && _vm.itemData === null) ||
      (!_vm.isItemView && _vm.itemData !== null)
        ? _c("div", { staticClass: "single__swiper-full-screen-modal" }, [
            _c(
              "div",
              {
                staticClass: "single__swiper-full-screen-modal-close",
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                }
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      "data-dismiss": "modal",
                      height: "26",
                      width: "27"
                    }
                  },
                  [
                    _c("use", {
                      attrs: {
                        "xlink:href": "#svg_close",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink"
                      }
                    })
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "single__swiper-full-screen-modal-img-wrapper" },
              [
                _c("img", {
                  staticClass: "single__swiper-full-screen-modal-img",
                  attrs: {
                    alt: _vm.$store.getters.currentItemVariation.texts.name1,
                    src: ""
                  }
                }),
                _vm._v(" "),
                _c("iframe", {
                  staticClass: "single__swiper-full-screen-modal-iframe",
                  attrs: {
                    src: "",
                    frameborder: "0",
                    allow:
                      "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                    allowfullscreen: "",
                    itemprop: "image"
                  }
                })
              ]
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }